<template>
  <!-- Empty circle when unchecked, green-filled circle with a check when checked -->
  <span
    class="check-circle-mark"
    :class="{ 'check-circle-mark--checked': checked }"
  >
    <font-awesome-icon
      v-if="checked"
      :icon="['fas', 'check']"
    />
  </span>
</template>

<script>
// Only the mark: CheckToggle (or whatever wraps it) decides what a click does
export default {
  name: 'CheckCircleMark',

  props: {
    checked: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
// The teal of the muted palette the Call Logs page uses (src/utils/channelColors.js), not Bootstrap's bright $success
$check-circle-mark-color: #4fb59a;

.check-circle-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  border: 2px solid $gray-500;
  border-radius: 50%;
  font-size: 0.7rem;
  vertical-align: middle;

  &--checked {
    border-color: $check-circle-mark-color;
    background-color: $check-circle-mark-color;
    color: $white;
  }
}
</style>
